import React, { useEffect, useState } from "react";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DashboardHeader from "../components/Other/DashboardHeader";
import PageHeaderTitle from "../components/pages/PageHeaderTitle";
import { useTranslation } from "react-i18next";
import {
  getNotifications,
  followUnfollow,
  clearNotification,
} from "../api/user";
import { toast } from "react-toastify";
import Loader from "../components/Loader";
import PageContainer from "../components/pages/PageContainer";
import { Link, useNavigate, useOutletContext } from "react-router-dom"; // Assuming you are using React Router
import moment from "moment-timezone";
import InfiniteScroll from "react-infinite-scroll-component";
import SmallLoader from "../components/smallLoader";

const Notifications = () => {
  const { t } = useTranslation();
  const [notifications, SetNotifications] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isDataFeteched, setisDataFeteched] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [last_page, setlast_page] = useState();
  const [apiCall, setApiCall] = useState(false);
  const navigate = useNavigate();
  const [hasMore, setHasMore] = useState(true);
  const [loader, setLoader] = useState(false);

  const handleLoadMore = () => {
    setItemsPerPage(itemsPerPage + 10);
    setPage(page + 1);
    if (page + 1 === last_page) {
      setHasMore(false);
    }
    fetchNotification(page + 1);
  };

  const fetchNotification = async (page) => {
    setLoader(true);
    try {
      if (!apiCall) {
        const response = await getNotifications(page ? page : 1);
        if (response?.data?.data?.data.length > 0) {
          SetNotifications((prevNotifications) => {
            return prevNotifications
              ? [...prevNotifications, ...response.data.data.data]
              : response.data.data.data;
          });
          setApiCall(true);
          setlast_page(response.data.data.last_page);
          setLoading(false);
          setLoader(false);
          setisDataFeteched(true);
          if (page === response.data.data.last_page) {
            setHasMore(false);
          }
        } else {
          setLoader(false);
          setHasMore(false);
        }
        setLoader(false);
        setApiCall(false);
        setLoading(false);
      }
    } catch (error) {
      setLoader(false);
      setApiCall(false);
      setLoading(false);
      setHasMore(false);
      console.error("Error:", error);
    }
  };
  useEffect(() => {
    notificationClear();
    if (!isDataFeteched) fetchNotification();
    return () => {
      // Cleanup logic if needed
    };
  }, [isDataFeteched]);

  const notificationClear = async () => {
    const data = 1;
    try {
      const response = await clearNotification(data);
      if (response.data.status == 200) {
        // console.log(response.data.status);
        localStorage.setItem("notificationCount", response?.data?.data?.badge);
        const messageCount = localStorage.getItem("messageCount");
        const myCustomEvent = new CustomEvent("myCustomEvent", {
          detail: {
            messageCount: messageCount,
            notificationCount: response?.data?.data?.badge,
          },
        });
        window.dispatchEvent(myCustomEvent);
      }
      // setLoading(false);
    } catch (error) {
      // setLoading(false);
      console.error("Error:", error);
    }
  };

  const renderImages = (post_image) => {
    if (Array.isArray(post_image)) {
      // If it's an array of images
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          {post_image.map((image, index) => (
            <img
              key={index}
              className="w-12 h-12 ml-2 rounded"
              src={image.image}
              alt={`Post ${index + 1} for `}
            />
          ))}
        </div>
      );
    } else if (typeof post_image === "string") {
      // If it's a single image
      return (
        <img
          className="w-12 h-12  mr-16 ml-[-10]"
          src={post_image}
          alt={`Post for ${"id"}`}
        />
      );
    }
  };

  // ... (other functions remain the same)

  const handleFollow = async (id) => {
    // console.log(id, "sss");
    const body = {
      user_uuid: id,
      request_status: 2,
    };
    try {
      // console.log(body);
      const response = await followUnfollow(body);

      if (response.status === 200) {
        // console.log(response.data);
        // toast.success(response.data.message);
        fetchNotification();
        // fetchProfile()
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const handleUnfollow = async (id) => {
    const body = {
      user_uuid: id,
      request_status: 1,
    };
    try {
      const response = await followUnfollow(body);
      if (response.status === 200) {
        // console.log(response.data);
        // toast.success(response.data.message);
        // fetchnotification();
        fetchNotification();
        // fetchProfile();
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  function calculateTimeAgo(created_at) {
    const currentDate = new Date();
    const createdAtDate = new Date(created_at);
    const timeDifference = currentDate.getTime() - createdAtDate.getTime();

    const secondsInMs = 1000;
    const minutesInMs = secondsInMs * 60;
    const hoursInMs = minutesInMs * 60;
    const daysInMs = hoursInMs * 24;
    const monthsInMs = daysInMs * 30;
    const yearsInMs = daysInMs * 365;

    if (timeDifference < minutesInMs) {
      return Math.round(timeDifference / secondsInMs) + "s";
    } else if (timeDifference < hoursInMs) {
      return Math.round(timeDifference / minutesInMs) + "m";
    } else if (timeDifference < daysInMs) {
      return Math.round(timeDifference / hoursInMs) + "h";
    } else if (timeDifference < monthsInMs) {
      return Math.round(timeDifference / daysInMs) + "d";
    } else if (timeDifference < yearsInMs) {
      return Math.round(timeDifference / monthsInMs) + "mo";
    } else {
      return Math.round(timeDifference / yearsInMs) + "y";
    }
  }

  const [sidebarToggle] = useOutletContext();

  const isTodayOrYesterday = (date) => {
    const currentDate = new Date();
    const messageDate = new Date(date);

    const currentDateString = currentDate.toLocaleDateString();
    const messageDateString = messageDate.toLocaleDateString();

    if (currentDateString === messageDateString) {
      return "Today";
    } else {
      return "Yesterday";
    }
  };

  const groupMessagesByDate = () => {
    return notifications && notifications.length > 0
      ? notifications.slice(0, itemsPerPage).reduce((result, notification) => {
        const messageDate = new Date(
          notification.created_at
        ).toLocaleDateString();
        const section = isTodayOrYesterday(notification.created_at);

        if (!result[section]) {
          result[section] = [];
        }
        result[section].push(notification);
        return result;
      }, {})
      : "";
  };

  const isMobileView = document.body.clientWidth <= 768;

  const handleSavedCharts = (chartData) => {
    const myCustomEvent = new CustomEvent("tickerEvent", {
      detail: {
        ticker: chartData?.stock_symbol,
      },
    });
    window.dispatchEvent(myCustomEvent);

    localStorage.setItem("ticker", chartData?.stock_symbol);
    localStorage.setItem("tickerEventImage", chartData?.image);
    navigate(`/charts`);
  };

  const handleImageChart = (chartData) => {
    console.log(chartData, "notificationD");
    const myCustomEvent1 = new CustomEvent("tickerEventImage", {
      detail: {
        imageChart: chartData?.image,
      },
    });
    window.dispatchEvent(myCustomEvent1);
  };

  return (
    <>
      <DashboardHeader toggle={sidebarToggle} />
      <PageHeaderTitle title={t("Notifications")} />
      <PageContainer>
        <div className="bg-white">
          <main className="h-full bg-#fbfcfc pt-4 justify-center">
            {
              <div
                className={
                  isMobileView
                    ? "pt-4 px-3 py-8 rounded-2xl border bg-white border-white-500 max-w-4xl w-full mx-auto mb-12"
                    : "p-8 rounded-2xl border bg-white border-white-500 max-w-4xl w-full mx-auto"
                }
              >
                {!loading && notifications && notifications.length > 0 ? (
                  <>
                    <InfiniteScroll
                      dataLength={notifications.length}
                      next={notifications.length > 9 && handleLoadMore}
                      hasMore={hasMore}
                      loader={loader && <SmallLoader />}
                      style={{
                        overflow: "hidden",
                      }}
                      endMessage={
                        !hasMore && (
                          <p style={{ textAlign: "center" }}>
                            <b>Yay! You have seen it all</b>
                          </p>
                        )
                      }
                    >
                      {Object.entries(groupMessagesByDate()).map(
                        ([section, notification], index) => (
                          <React.Fragment key={index}>
                            {" "}
                            {/* Adding key to the Fragment */}
                            <span className="text-[#707070] mb-6 flex justify-start md:mr-[1.8rem] mr-0 -mb-4 md:ml-0 mt-4 ml-[1.5rem]">
                              {section === "Today"
                                ? "Today"
                                : section === "Yesterday"
                                  ? "Yesterday"
                                  : "Yesterday"}
                            </span>
                            {notification &&
                              notification
                                .slice(0, itemsPerPage)
                                .map((notificationD) => {
                                  return (
                                    <div
                                      onClick={() => {
                                        if (
                                          notificationD?.type ==
                                          "friend_reqest" ||
                                          notificationD?.type == "subscription"
                                        ) {
                                          navigate(
                                            `/profile/${notificationD?.send_by}`
                                          );
                                        } else if (
                                          notificationD?.type == "SAVED_CHART"
                                        ) {
                                          handleImageChart(
                                            notificationD?.notification_data
                                              ?.chart
                                          );
                                          handleSavedCharts(
                                            notificationD?.notification_data
                                              ?.chart
                                          );
                                        } else if(
                                          notificationD?.type === "game_winner" || notificationD?.type === "game_runners_up"
                                        ){
                                          navigate(
                                            `/contest/${notificationD?.notification_data?.game?.vanity_url}`
                                          );
                                        }else {
                                          navigate(
                                            `/feed/${notificationD?.notification_data?.post_id}`
                                          );
                                        }
                                      }}
                                    >
                                      <div
                                        key={notificationD.id}
                                        className={
                                          isMobileView
                                            ? "flex items-start px-2 py-4 hover:bg-gray-200 rounded bg-white"
                                            : "flex items-start p-4 hover:bg-gray-200 rounded bg-white"
                                        }
                                      >
                                        <div className="mr-4">
                                          {notificationD.title ===
                                            "Unrecognized Login" ? (
                                            <FontAwesomeIcon
                                              className="h-8 w-8 rounded-full text-yellow-500"
                                              icon={faCircleExclamation}
                                            />
                                          ) : (
                                            <img
                                              src={notificationD?.sender?.image}
                                              alt={`Avatar for ${notificationD.user}`}
                                              className="h-12 w-12 rounded-full"
                                            />
                                          )}
                                        </div>

                                        <div className="flex flex-col flex-1">
                                          <div className="flex items-center mb-2">
                                            <p className="mr-2 font-poppins text-black-500 overflow-hidden overflow-ellipsis">
                                              {/* <strong>{notification.sender.user_name}</strong>{" "} */}

                                          {(notificationD.type === "game_winner" || notificationD.type === "game_runners_up") ? (
                                            <>
                                              {notificationD.type === "game_winner" &&
                                                `🎉 Congratulations on being the winner of the ''${notificationD.notification_data?.game?.title}'' league! 🏆`}

                                              {notificationD.type === "game_runners_up" &&
                                                `${notificationD.notification_data?.winner} is the winner of the ''${notificationD.notification_data?.game?.title}'' league! 🏆`}
                                            </>
                                          ) : (
                                            notificationD.body
                                          )}


                                              {
                                                notificationD.notification_data
                                                  ?.caption
                                              }
                                            </p>
                                          </div>
                                          {notificationD.title === "Follow" && (
                                            <>
                                              {notificationD.sender
                                                ?.is_follow_by_me ? (
                                                <button
                                                  onClick={() =>
                                                    handleUnfollow(
                                                      notificationD
                                                        .notification_data?.uuid
                                                    )
                                                  }
                                                  className="py-2 px-6 ml-auto border border-yellow-500 bg-yellow-500 rounded-xl text-white hover:bg-yellow-400 hover:border-yellow-400"
                                                  style={{
                                                    backgroundColor: "#B69D31",
                                                  }}
                                                >
                                                  Following
                                                </button>
                                              ) : (
                                                <button
                                                  onClick={() =>
                                                    handleFollow(
                                                      notificationD
                                                        .notification_data?.uuid
                                                    )
                                                  }
                                                  className="py-2 px-6 ml-auto border border-yellow-500 bg-yellow-500 rounded-xl text-white hover:bg-yellow-400 hover:border-yellow-400"
                                                  style={{
                                                    backgroundColor: "#B69D31",
                                                  }}
                                                >
                                                  Follow
                                                </button>
                                              )}
                                            </>
                                          )}
                                          {/* ... (other conditions remain the same) */}
                                          <div className="flex justify-center px-0 my-2 sm:px-10 flex-wrap">
                                            {renderImages(
                                              notificationD.notification_data
                                                ?.post_image
                                            )}
                                          </div>
                                          <p className="text-gray-500 text-sm">
                                            {calculateTimeAgo(
                                              notificationD.created_at
                                            )}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                          </React.Fragment>
                        )
                      )}
                    </InfiniteScroll>
                    {/* {notifications.length > 10 && page === last_page && (
                      <div>
                        <p style={{ textAlign: "center" }}>
                          <b>Yay! You have seen it all.</b>
                        </p>
                      </div>
                    )} */}
                    {/* <div>
                      {page !== last_page && (
                        <div className="text-center">
                          <button
                            className="py-2 px-4 w-auto mt-2 mr-16 text-lg font-bold text-greenXD justify-end"
                            onClick={handleLoadMore}
                          >
                            More
                          </button>
                        </div>
                      )}
                    </div> */}
                  </>
                ) : loading ? (
                  <Loader dark />
                ) : (
                  <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                    <p>No Notifications Found</p>
                  </div>
                )}
              </div>
            }
          </main>
        </div>
      </PageContainer>
    </>
  );
};

export default Notifications;
